import {
  Button,
  Modal,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import React from "react";
import { baseURL } from "../../Config/config";

const AddBusinessUser = (props) => {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");

  // New CADENCE user fields
  const [fullName, setFullName] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [workspace, setWorkspace] = React.useState("");

  const [loading, setLoading] = React.useState(false);

  const resetForm = () => {
    setUsername("");
    setPassword("");
    setFullName("");
    setTitle("");
    setCompany("");
    setWorkspace("");
  };

  const addUser = async () => {
    // -----------------------------
    // Validation
    // -----------------------------
    if (!username.trim()) {
      alert("Please enter username");
      return;
    }

    if (!password.trim()) {
      alert("Please enter password");
      return;
    }

    if (!fullName.trim()) {
      alert("Please enter full name");
      return;
    }

    if (!company.trim()) {
      alert("Please enter company");
      return;
    }

    if (!workspace.trim()) {
      alert("Please enter workspace");
      return;
    }

    // -----------------------------
    // Data sent to Flask
    // -----------------------------
    const body = {
      username: username.trim(),
      password: password,

      full_name: fullName.trim(),
      title: title.trim(),
      company: company.trim(),
      workspace_id: workspace.trim(),
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };

    try {
      setLoading(true);

      let res = await fetch(
        `${baseURL}/addbusinessuser`,
        requestOptions
      );

      res = await res.json();

      if (res.code) {
        resetForm();

        props.toggleModal(false);
        props.refreshList(true);

        return;
      }

      alert(res.message || "Some Error");
    } catch (error) {
      console.log("Add Business User Error:", error);
      alert("Some Error");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (loading) return;

    resetForm();
    props.toggleModal(false);
  };

  return (
    <div>
      <Modal
        open={props.modalState}
        onClose={handleClose}
        sx={{
          display: "flex",
          flex: 1,
          justifyContent: "center",
          padding: 0,
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            width: "360px",
            maxHeight: "75vh",
            overflowY: "auto",
            marginTop: "8%",
            padding: "30px 25px",
            borderRadius: "8px",
          }}
        >
          <Typography
            sx={{
              fontSize: "15px",
              fontWeight: 600,
              marginBottom: 2,
            }}
          >
            Add New User
          </Typography>

          {/* Username */}
          <TextField
            label="Username"
            variant="outlined"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            InputProps={{
              style: { fontSize: "12px" },
            }}
            InputLabelProps={{
              style: { fontSize: "12px" },
            }}
            sx={{
              backgroundColor: "#fff",
              marginBottom: "12px",
            }}
            size="small"
            fullWidth
          />

          {/* Password */}
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              style: { fontSize: "12px" },
            }}
            InputLabelProps={{
              style: { fontSize: "12px" },
            }}
            sx={{
              backgroundColor: "#fff",
              marginBottom: "12px",
            }}
            size="small"
            fullWidth
          />

          {/* Full Name */}
          <TextField
            label="Full Name"
            variant="outlined"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            InputProps={{
              style: { fontSize: "12px" },
            }}
            InputLabelProps={{
              style: { fontSize: "12px" },
            }}
            sx={{
              backgroundColor: "#fff",
              marginBottom: "12px",
            }}
            size="small"
            fullWidth
          />

          {/* Title */}
          <TextField
            label="Title / Role"
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g. Sales Manager"
            InputProps={{
              style: { fontSize: "12px" },
            }}
            InputLabelProps={{
              style: { fontSize: "12px" },
            }}
            sx={{
              backgroundColor: "#fff",
              marginBottom: "12px",
            }}
            size="small"
            fullWidth
          />

          {/* Company */}
          <TextField
            label="Company"
            variant="outlined"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            placeholder="e.g. OptimizeGS"
            InputProps={{
              style: { fontSize: "12px" },
            }}
            InputLabelProps={{
              style: { fontSize: "12px" },
            }}
            sx={{
              backgroundColor: "#fff",
              marginBottom: "12px",
            }}
            size="small"
            fullWidth
          />

          {/* Workspace */}
          <TextField
            label="Workspace"
            variant="outlined"
            value={workspace}
            onChange={(e) => setWorkspace(e.target.value)}
            placeholder="e.g. optimizegs-sales"
            helperText="Users in the same workspace will share CADENCE data."
            InputProps={{
              style: { fontSize: "12px" },
            }}
            InputLabelProps={{
              style: { fontSize: "12px" },
            }}
            FormHelperTextProps={{
              style: { fontSize: "10px" },
            }}
            sx={{
              backgroundColor: "#fff",
              marginBottom: "20px",
            }}
            size="small"
            fullWidth
          />

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <Button
              onClick={handleClose}
              variant="outlined"
              size="small"
              disabled={loading}
              sx={{
                fontSize: "12px",
                textTransform: "none",
              }}
            >
              Cancel
            </Button>

            <Button
              onClick={addUser}
              variant="contained"
              disabled={loading}
              sx={{
                color: "white",
                cursor: "pointer",
                fontSize: "12px",
                textDecoration: "none",
                textTransform: "none",
                minWidth: "90px",
              }}
              size="small"
            >
              {loading ? (
                <CircularProgress
                  size={18}
                  sx={{ color: "#fff" }}
                />
              ) : (
                "Add User"
              )}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddBusinessUser;